export default [
  { path: '/main/file', name: 'MainFile', component: () => import(/* webpackChunkName: "main-file" */ './index.vue') }
]
